module.exports = __webpack_public_path__ + "img/art-page3-img-1.ab4e52c0.jpg";